import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Card } from "reactstrap";

import { Block, BlockBetween, BlockTitle } from "../../Component";
import UpdatableText from "../../shared/UpdatabaleText";
import BlockUpdateButton from "../../button/BlockUpdateButton";
import RichTextEditor from "../../input/rich-text/RichTextEditor";
import RichTextDisplayComponent from "../../input/rich-text/RichTextDisplayComponent";

import partnerService from "../../../services/partnerService";
import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import { usePartnerPageContext } from "../../../hooks/usePartnerPageContext";
import EventEmitter, { EVENT_TOPICS } from "../../../utilities/eventUtils";
import { LANGUAGE_KEYS } from "../../../utilities/constants";
import { parseRichText } from "../../../utilities/formatUtils";

const PartnerDescriptionBlock = () => {
  const { partnerId } = useParams();
  const { handleSubmit } = useForm();
  const [onFetch] = useBeManualFetcher();
  const { singlePartner } = usePartnerPageContext();

  const [hasEditClicked, setHasEditClicked] = useState(false);
  const [uzDescription, setUzDescription] = useState(() =>
    parseRichText(singlePartner?.description?.[LANGUAGE_KEYS.UZ])
  );
  const [ruDescription, setRuDescription] = useState(() =>
    parseRichText(singlePartner?.description?.[LANGUAGE_KEYS.RU])
  );
  const [enDescription, setEnDescription] = useState(() =>
    parseRichText(singlePartner?.description?.[LANGUAGE_KEYS.EN])
  );

  function handleOnEditClicked() {
    setHasEditClicked((prev) => !prev);
  }

  async function onFormSubmit() {
    const data = {
      description: {
        [LANGUAGE_KEYS.UZ]: JSON.stringify(uzDescription),
        [LANGUAGE_KEYS.RU]: JSON.stringify(ruDescription),
        [LANGUAGE_KEYS.EN]: JSON.stringify(enDescription),
      },
    };

    return await onFetch({
      action: () => partnerService.updatePartner(partnerId, { data }),
      onLoad: (updatedPartner) => {
        EventEmitter.emit(EVENT_TOPICS.ON_PARTNER_UPDATED, { updatedPartner });
        handleOnEditClicked();
      },
      successMessage: "Partner description updated successfully",
    });
  }

  const descriptionFields = [
    {
      title: "O'zbekcha",
      languageKey: LANGUAGE_KEYS.UZ,
      value: uzDescription,
      setValue: setUzDescription,
    },
    {
      title: "На русском",
      languageKey: LANGUAGE_KEYS.RU,
      value: ruDescription,
      setValue: setRuDescription,
    },
    {
      title: "In English",
      languageKey: LANGUAGE_KEYS.EN,
      value: enDescription,
      setValue: setEnDescription,
    },
  ];

  return (
    <Card className="card-inner">
      <Block>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <BlockBetween>
            <BlockTitle tag="h5">Description</BlockTitle>
            <BlockUpdateButton
              hasEditClicked={hasEditClicked}
              handleOnEditClicked={handleOnEditClicked}
            />
          </BlockBetween>
          {descriptionFields.map((field) => {
            const savedValue = singlePartner?.description?.[field.languageKey];

            return (
              <UpdatableText
                key={field.languageKey}
                title={field.title}
                defaultValue={
                  // Slate faqat mount paytidagi qiymatni oladi — saqlangandan
                  // keyin yangilanishi uchun key saqlangan matnga bog'langan.
                  <RichTextDisplayComponent
                    key={savedValue ?? "empty"}
                    value={parseRichText(savedValue)}
                  />
                }
                editableValueComponent={
                  <RichTextEditor
                    value={field.value}
                    setValue={field.setValue}
                  />
                }
                onEditClicked={hasEditClicked}
              />
            );
          })}
        </form>
      </Block>
    </Card>
  );
};

export default PartnerDescriptionBlock;
